import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "button", "buttonText"];
  static values = {
    show: String,
    hide: String,
    state: {
      type: Boolean,
      default: true,
    },
  };
  static classes = ["visibility"];

  declare buttonTarget: HTMLButtonElement;
  declare buttonTextTarget: HTMLSpanElement;
  declare contentTarget: HTMLElement;
  declare hideValue: string;
  declare showValue: string;
  declare stateValue: boolean;
  declare visibilityClass: string;
  declare hasVisibilityClass: boolean;

  connect(): void {
    this.updateButtonAttributes();
    this.updateButtonText();
  }

  toggle(): void {
    const isNowVisible = !this.isVisible();
    this.stateValue = isNowVisible;

    if (isNowVisible) {
      this.contentTarget.classList.remove(this.visibilityClassOrDefault());
    } else {
      this.contentTarget.classList.add(this.visibilityClassOrDefault());
    }

    this.updateButtonAttributes();
    this.updateButtonText();
  }

  updateButtonText() {
    this.buttonTextTarget.textContent = this.isVisible()
      ? this.hideValue
      : this.showValue;
  }

  updateButtonAttributes() {
    this.buttonTarget.setAttribute(
      "aria-expanded",
      this.isVisible() ? "true" : "false"
    );
  }

  isVisible(): boolean {
    return !this.contentTarget.classList.contains(
      this.visibilityClassOrDefault()
    );
  }

  visibilityClassOrDefault(): string {
    return this.hasVisibilityClass ? this.visibilityClass : "d-none";
  }
}
